// Replaces js/src/templates/form.html. Returns raw HTML as a string.

export function formTemplate() {
  return `
<div class="grid" id="whereToBuy">
  <div class="locations-search" id="mapSearchBox">
    <form class="mapSearch" novalidate>
      <input type="text" id="LocationQuery" name="query" placeholder="Zip Code"
             autocomplete="postal-code" inputmode="numeric" pattern="\\d{5}" maxlength="5">
      <input type="submit" id="locateButton" value="Find">
      <div class="locations-search--validation" hidden>
        <h4>No sales reps were found.
          <a href="https://portal.essilorpro.com/contact-us">Contact Us</a>
          and we'll have the nearest representative get in touch with you.</h4>
      </div>
      <div class="locations-zip--validation" hidden>
        <h4>Please enter a valid zip code</h4>
      </div>
      <div class="locations-zip--sys-error" hidden>
        <h4>An error occurred. Please try again.</h4>
      </div>
    </form>
  </div>
  <div class="locations-listings" id="mapListing"></div>
</div>
`.trim();
}
